// Menu links such as "/#mukhtarat" jump to a section on the homepage.
// 1. On the English site the homepage is /en, so "/#x" would open the
//    Arabic homepage. Rewrite those links to the current language's root.
// 2. Clicking one while already on the homepage only scrolls, so the menu
//    drawer would stay open over the page. Close it first.
(function () {
  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  function fixLinks() {
    var base = root();
    if (base === '/') return;
    document.querySelectorAll('a[href^="/#"]').forEach(function (a) {
      a.setAttribute('href', base + a.getAttribute('href').slice(1));
    });
  }

  document.addEventListener('click', function (e) {
    var a = e.target.closest('a[href*="#"]');
    if (!a) return;
    var url;
    try { url = new URL(a.getAttribute('href'), window.location.href); } catch (err) { return; }
    if (url.origin !== window.location.origin || !url.hash) return;
    var here = window.location.pathname.replace(/\/$/, '');
    var there = url.pathname.replace(/\/$/, '');
    if (here !== there) return;
    var target = document.getElementById(decodeURIComponent(url.hash.slice(1)));
    if (!target) return;
    if (a.closest('#m-nav')) {
      var close = document.querySelector('#m-nav [data-mnav-close]');
      if (close) close.click();
    }
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', fixLinks);
  } else {
    fixLinks();
  }
})();

// Judge.me review form, Arabic pages: the label under the 5th star reads
// «ممتاز». Judge.me's own Arabic text is «جيد», which undersells 5 stars.
// The settings object is patched before the form opens (on page load and on
// every click), so the form reads the new text when it is drawn.
(function () {
  if ((document.documentElement.lang || '').indexOf('ar') !== 0) return;
  function patch() {
    var s = window.jdgmSettings;
    if (s && s.five_star_review_guidance_text !== 'ممتاز') s.five_star_review_guidance_text = 'ممتاز';
  }
  patch();
  document.addEventListener('DOMContentLoaded', patch);
  window.addEventListener('load', patch);
  document.addEventListener('click', patch, true);
})();
